import React from 'react';

import { BorderColor as BorderColorIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router';

import { appRoutes, RouterEntitiesId } from '@clearverify/constants';
import type { Nullable } from '@clearverify/types';

import { VerificationRequestForReportItemFragment } from 'src/api';
import { TableRowAction } from 'src/components/table';
import { buildUrl } from 'src/utils/router';

export function useVerificationRequestsTableRowActions() {
  const navigate = useNavigate();

  const navigateToDetails = React.useCallback(
    (inboxItemId: Nullable<string>) => {
      navigate(
        buildUrl(appRoutes.inbox.inboxItem, {
          [RouterEntitiesId.inboxItem]: String(inboxItemId),
        }),
      );
    },
    [navigate],
  );

  const viewDetails: TableRowAction<VerificationRequestForReportItemFragment> = React.useMemo(
    () => ({
      startIcon: React.createElement(BorderColorIcon),
      actionName: 'View Details',
      onAction: verificationRequestItem => navigateToDetails(verificationRequestItem.inboxItemId),
    }),
    [navigateToDetails],
  );

  return [viewDetails];
}
